'use client';
import { CodeBlock } from 'react-code-block';
import { getFontFamily } from '@/theme/typography';
import { CABAL_PRISM_THEME, COMPACT_PREVIEW_DATA_NAME, COMPACT_PREVIEW_FONT_SIZE_PX, COMPACT_PREVIEW_LINE_HEIGHT, COMPACT_PREVIEW_PADDING, DEFAULT_CODE_LANGUAGE, } from './cmarkdowncodeConstants';
interface CmarkdowncodeCompactPreviewProps {
    code: string;
    language: string | undefined;
}
export function CmarkdowncodeCompactPreview({ code, language }: CmarkdowncodeCompactPreviewProps) {
    const resolvedLanguage = language || DEFAULT_CODE_LANGUAGE;
    return (
      <div style={{
            position: 'absolute',
            inset: 0,
            padding: COMPACT_PREVIEW_PADDING,
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
        }}>
        <CodeBlock code={code} language={resolvedLanguage} theme={CABAL_PRISM_THEME}>
          <CodeBlock.Code style={{
            margin: 0,
            padding: 0,
            fontFamily: getFontFamily(),
            fontSize: COMPACT_PREVIEW_FONT_SIZE_PX,
            lineHeight: COMPACT_PREVIEW_LINE_HEIGHT,
            whiteSpace: 'pre',
            backgroundColor: 'transparent',
            backgroundImage: 'none',
        }}>
            <CodeBlock.LineContent>
              <CodeBlock.Token />
            </CodeBlock.LineContent>
          </CodeBlock.Code>
        </CodeBlock>
      </div>
    );
}
